{
  "label": "System name",
  "tooltip": {
    "iconLabel": "System name hint",
    "systemUsage": "Used inside the system",
    "allowedCharacters": "Allowed characters: Latin letters (a-z), digits (0-9), and underscore (_)",
    "unique": "Must be unique within its scope",
    "immutable": "Cannot be edited after the entity is created"
  }
}